export const DISCUSS_FORUM_URL = "https://discuss.meshery.io";